export default function Logo({ compact = false }) {
  return (
    <div className="flex flex-col items-center leading-none select-none" data-testid="breeze-logo">
      <span className={`font-extrabold tracking-tight ${compact ? "text-lg" : "text-xl sm:text-2xl"}`}>
        <span className="hero-title-gradient">BREEZE</span>
      </span>
      <span className={`font-semibold tracking-[0.32em] uppercase text-sky-400/90 ${compact ? "text-[8px]" : "text-[9px] sm:text-[10px]"}`}>
        Financial Group
      </span>
    </div>
  );
}
